import { environment } from '@environments/environment';

/**
 * Whether a request targets our backend API.
 *
 * Excludes requests to other APIs (e.g. identity server).
 */
export const isApiRequest = (url: string): boolean =>
  url.startsWith(environment.apiBaseUrl);
